let data = [
  {
    'label': 'OPO',
    'value': 'opo'
  },
  {
    'label': 'UNOS',
    'value': 'unos'
  },
  {
    'label': 'State',
    'value': 'state'
  }
]

data.find = function (id) {
  let cnt = this.length
  for (let i = 0; i < cnt; i++) {
    if (this[i].value === id) {
      return this[i]
    }
  }
  return null
}

export default data



// WEBPACK FOOTER //
// ./src/options/region-modes.js